<nb-card>
  <div
    *ngIf="mode !== 'home' && exercise.coverUrl && exercise.coverUrl != ''"
    class="picture"
    [style.background-image]="'url(' + exercise.coverUrl + ')'"
    (click)="onClick()"
  ></div>
  <div
    *ngIf="mode !== 'home' && (!exercise.coverUrl || exercise.coverUrl == '')"
    class="picture"
    [style.background-image]="'url(' + defaultCover + ')'"
    (click)="onClick()"
  ></div>

  <div *ngIf="mode !== 'detail'" class="summary">
    <div class="item">
      <div class="avatar">
        <ngx-view-user-display
          [user]="exercise.author"
          [mode]="'avatar'"
        ></ngx-view-user-display>
      </div>

      <div class="content">
        <ngx-view-user-display
          [user]="exercise.author"
          [mode]="'name'"
        ></ngx-view-user-display>
        <ngx-view-time-ago
          [currentDate]="exercise.createdOn"
        ></ngx-view-time-ago>

        <div *ngIf="mode !== 'home' && exercise.refTitle" class="text-link">
          <nb-icon icon="globe-outline"></nb-icon>
          <a class="link" (click)="navigateRef(exercise)">
            {{
              exercise.refTitle.length < 60
                ? exercise.refTitle
                : exercise.refTitle.substring(0, 60) + "..."
            }}
          </a>
        </div>

        <div *ngIf="mode !== 'home' && !exercise.refTitle" class="text-link">
          <nb-icon icon="hash-outline"></nb-icon>
          <ngx-view-tags
            [tags]="exercise.tags"
            (onTagSelected)="tagSelected($event)"
          ></ngx-view-tags>
        </div>

        <h6
          *ngIf="exercise.title"
          (click)="onClick()"
          class="link text-heading"
        >
          {{ exercise.title }}
        </h6>

        <div class="overview">
          <nb-actions size="none">
            <nb-action>
              <nb-icon status="info" icon="list-outline"></nb-icon>
              <span>{{ exercise.noExUser ? exercise.noExUser : "." }}</span>
            </nb-action>

            <nb-action>
              <nb-icon status="success" icon="award-outline"></nb-icon>
              <span>
                {{
                  exercise.noExUserCompleted ? exercise.noExUserCompleted : "."
                }}
              </span>
            </nb-action>
          </nb-actions>

          <nb-actions size="none">
            <nb-action>
              <nb-icon [status]="'info'" icon="layers-outline"></nb-icon>
              <span>{{ exercise.noQuiz ? exercise.noQuiz : "0" }}</span>
            </nb-action>

            <nb-action>
              <nb-icon status="success" icon="percent-outline"></nb-icon>
              <span
                >{{
                  exercise.percentCompleted > 0
                    ? exercise.percentCompleted
                    : "~"
                }}
              </span>
            </nb-action>

            <nb-action>
              <nb-icon
                status="warning"
                class="action-icon"
                icon="clock-outline"
              ></nb-icon>
              <span
                >{{ exercise.duration > 0 ? exercise.duration + " p" : "~" }}
              </span>
            </nb-action>
          </nb-actions>
        </div>
      </div>
    </div>
  </div>

  <nb-card-footer *ngIf="mode == 'home'">
    <nb-actions class="button-actions">
      <nb-action>
        <nb-icon class="action-icon" icon="like" pack="liked-icon"></nb-icon>
        <span>{{ exercise.noLiked ? exercise.noLiked : "." }}</span>
      </nb-action>

      <nb-action>
        <nb-icon icon="message-square-outline"></nb-icon>
        <span>{{ exercise.noComment ? exercise.noComment : "." }}</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
